import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { LabelField } from 'components'
import { Chip } from 'components/chips'
import { CompanyDto } from 'dtos'

interface CompanyHeroCardProps {
  company: CompanyDto
}

export default function CompanyHeroCard({ children, company }: React.PropsWithChildren<CompanyHeroCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm={true} container alignItems='center' spacing={0}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  {company.name}
                </Typography>
              </Grid>

              {company.isActive && (
                <Grid item>
                  <Chip variant='green'>Active</Chip>
                </Grid>
              )}

              {!company.isActive && (
                <Grid item>
                  <Chip variant='gray'>Inactive</Chip>
                </Grid>
              )}

              {company.isAttorneyCompany && (
                <Grid item>
                  <Chip variant='blue'>Attorney Company</Chip>
                </Grid>
              )}

              {company.isBrokerCompany && (
                <Grid item>
                  <Chip variant='yellow'>Broker</Chip>
                </Grid>
              )}

              {company.isBuyerCompany && (
                <Grid item>
                  <Chip variant='purple'>Buyer Company</Chip>
                </Grid>
              )}

              {company.isExporterCompany && (
                <Grid item>
                  <Chip variant='orange'>Exporter Company</Chip>
                </Grid>
              )}

              {company.isClusterConversionCompany && (
                <Grid item>
                  <Chip variant='pink'>Cluster Conversion Company</Chip>
                </Grid>
              )}

              {company.isClusterProgrammerCompany && (
                <Grid item>
                  <Chip variant='teal'>Cluster Programmer Company</Chip>
                </Grid>
              )}

              {company.isInboundTransporterCompany && (
                <Grid item>
                  <Chip variant='brown'>Inbound Transporter Company</Chip>
                </Grid>
              )}

              {company.isImporterDealerCompany && (
                <Grid item>
                  <Chip variant='lime'>Importer Dealer Company</Chip>
                </Grid>
              )}

              {company.isInspectionCompany && (
                <Grid item>
                  <Chip variant='indigo'>Inspection Company</Chip>
                </Grid>
              )}

              {company.isInsuranceCompany && (
                <Grid item>
                  <Chip variant='cyan'>Insurance Company</Chip>
                </Grid>
              )}

              {company.isLienHolderCompany && (
                <Grid item>
                  <Chip variant='turquoise'>Lien Holder Company</Chip>
                </Grid>
              )}

              {company.isMichiganSOSBranch && (
                <Grid item>
                  <Chip variant='maroon'>Michigan Secretary Of State Branch</Chip>
                </Grid>
              )}

              {company.isOutboundTransporterCompany && (
                <Grid item>
                  <Chip variant='amber'>Outbound Transporter Company</Chip>
                </Grid>
              )}

              {company.isRegisteredImporterCompany && (
                <Grid item>
                  <Chip variant='violet'>Registered Importer Company</Chip>
                </Grid>
              )}

              {company.isSuretyCompany && (
                <Grid item>
                  <Chip variant='olive'>Surety Company</Chip>
                </Grid>
              )}

              {company.isTitleDestinationCompany && (
                <Grid item>
                  <Chip variant='navy'>Title Destination Company</Chip>
                </Grid>
              )}

              {company.isVehicleDestinationCompany && (
                <Grid item>
                  <Chip variant='magenta'>Vehicle Destination Company</Chip>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm='auto' container alignItems='center' spacing={1}>
              {children}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Website' value={company.website} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Notes' value={company.notes} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
